import { Component, Input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { ISubmittalPackages } from '../../../models/properties/ISubmittalPackages';

@Component({
    selector: 'app-multi-pdf-report-dropdown',
    templateUrl: './multi-pdf-report-dropdown.component.html',
    standalone: true,
    imports: [MatFormFieldModule, MatSelectModule, ReactiveFormsModule],
    styleUrls: ['./multi-pdf-report-dropdown.component.scss']
})
export class MultiPdfReportDropdownComponent {
    @Input() reportsList: ISubmittalPackages[] = [];
    @Input() control!: FormControl<string>;
    @Input() showEmptyOption: boolean = false;
}
